export const BASE_LAYOUT_TOAST_KEY = 'BASE_LAYOUT';
